module.exports = __webpack_public_path__ + "static/media/email-editor.32f08029.png";